import React from 'react';
import Reveal from './Reveal';

/**
 * Crews: small, private, invite-only, reactions not comments, a challenge
 * that counts sessions. The mock is illustrative and hidden from assistive
 * technology behind one description.
 */
const points = [
  { title: 'Small', body: 'Up to twelve people. Small enough that you notice who is missing.' },
  {
    title: 'Private',
    body: 'Invite-only, and invites expire. No public profile, no follower count, no feed.',
  },
  {
    title: 'Reactions and check-ins, not chat',
    body: 'A reaction says “seen you”. A check-in - “Training today”, “Rest day” - says where you are. Nothing to scroll, nothing to perform.',
  },
  {
    title: 'A challenge anyone can win',
    body: 'The weekly challenge counts sessions, not kilos - every member can contribute equally.',
  },
  {
    title: 'Looked after',
    body: 'Every crew has an owner and can have moderators who remove members. Anyone can report or block.',
  },
];

const activity = [
  { who: 'Maya', what: 'finished Kettlebell Conditioning', time: '22 min', cheers: 4 },
  { who: 'Jon', what: 'finished Foundations', time: '18 min', cheers: 6 },
  { who: 'Ana', what: 'checked in: Rest day', time: '', cheers: 2, rest: true },
  { who: 'Sam', what: 'shared a record: press 16 kg × 5', time: '', cheers: 9, pr: true },
];

const Crews = () => (
  <section id="crews" className="section" aria-labelledby="crews-headline">
    <div className="section-inner split split-top">
      <Reveal>
        <p className="eyebrow eyebrow-crew">Crews</p>
        <h2 id="crews-headline" className="h2">
          People who show up with you.
        </h2>
        <dl className="points">
          {points.map((p) => (
            <div key={p.title}>
              <dt>{p.title}</dt>
              <dd>{p.body}</dd>
            </div>
          ))}
        </dl>
        <p className="small">
          Your crew sees your display name, what you trained, for how long, your check-ins and any
          record you choose to share. Never your heart rate, your sets or your notes.
        </p>
      </Reveal>

      <Reveal>
        <div
          className="panel mock-crewfeed"
          role="img"
          aria-label="A crew called Tuesday Bells: the weekly challenge at 9 of 12 sessions, and four updates - Maya finished Kettlebell Conditioning in 22 minutes, Jon finished Foundations in 18 minutes, Ana checked in with Rest day, Sam shared a record, a 16 kg press for 5 - each with a count of reactions."
        >
          <div aria-hidden="true">
            <div className="mock-crew-head">
              <div className="mock-crew-row">
                <span className="mock-crew-name">Tuesday Bells</span>
                <span className="mock-crew-count">9 / 12 this week</span>
              </div>
              <div className="mock-cells">
                {Array.from({ length: 12 }, (_, i) => (
                  <span key={i} className={i < 9 ? 'on' : ''} />
                ))}
              </div>
            </div>
            <ul className="mock-activity">
              {activity.map((a) => (
                <li key={a.who}>
                  <span className={`mock-avatar ${a.pr ? 'is-pr' : ''} ${a.rest ? 'is-rest' : ''}`}>
                    {a.who[0]}
                  </span>
                  <span className="mock-activity-text">
                    <strong>{a.who}</strong> {a.what}
                    {a.time ? <em> · {a.time}</em> : null}
                  </span>
                  <span className={a.pr ? 'mock-react is-pr' : 'mock-react'}>
                    {a.cheers} cheers
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Crews;
